module.exports = __webpack_public_path__ + "img/rejestr.43757e76.svg";